<ng-container *transloco="let t">
  <div class="flex h-full w-full flex-col gap-2 rounded-xl border border-gray-100 bg-white px-4 py-3 shadow-xs">
    @if (withActionsHeader()) {
      <div class="flex items-start justify-end gap-2">
        @if (withRestoreColumns()) {
          <button iButton variant="secondary" (click)="columnRestore.emit()">
            {{ t("common.restore_columns") }}
          </button>
        }
        @if (withExport()) {
          <button iButton variant="secondary" (click)="export.emit()">
            <IIcon name="upload" />
            {{ t("common.export") }}
          </button>
        } @else if (withImport()) {
          <button iButton variant="secondary" (click)="import.emit()">
            <IIcon name="import" />
            {{ t("common.import") }}
          </button>
        }
      </div>
    }
    <div class="ag-theme-quartz flex flex-1 justify-center">
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
